import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";
import { esMaster, posGet } from "./posApi";

function BotonesPuntoVenta() {
  const { user } = useContext(AuthContext);
  const master = esMaster(user);
  const u = user || {};
  const conAcceso = !!u.rolTiendas;
  const p = (k) => conAcceso && !!u[k];
  const [porRecibir, setPorRecibir] = useState(0);
  const [stockBajo, setStockBajo] = useState(null);
  const [pedidos, setPedidos] = useState(0);
  useEffect(() => {
    if (conAcceso && u.posRecibir) posGet("/traspasos/pendientes").then((r) => setPorRecibir(r.pendientes)).catch(() => {});
    if (conAcceso && u.posTraspasos) posGet("/solicitudes/pendientes").then((r) => setPedidos(r.porEnviar)).catch(() => {});
  }, [conAcceso, u.posRecibir, u.posTraspasos]);
  useEffect(() => {
    // Usuario de tienda: su tienda; master: todas
    if (conAcceso && u.posInventario) posGet("/stockBajo/conteo").then(setStockBajo).catch(() => {});
  }, [conAcceso, u.posInventario]);

  const SECCIONES = [
    { section: "Caja", items: [
      { label: "Vender", icon: "fas fa-cash-register", color: "#10b981", href: "/PosVenta", desc: "Punto de venta", enabled: p("posVender") },
      { label: "Corte de caja", icon: "fas fa-money-check-alt", color: "#f59e0b", href: "/PosCorte", desc: "Entrega del día", enabled: p("posCorte") },
      { label: "Ventas", icon: "fas fa-file-invoice-dollar", color: "#6366f1", href: "/PosVentas", desc: "Tickets y cancelaciones", enabled: p("posVentas") },
      { label: "Gastos y retiros", icon: "fas fa-wallet", color: "#f59e0b", href: "/PosCaja", desc: "Salidas y fondo de efectivo", enabled: p("posCaja") },
      { label: "Devoluciones y cambios", icon: "fas fa-undo", color: "#ef4444", href: "/PosDevolucion", desc: "Sobre un ticket de la tienda", enabled: p("posDevoluciones") },
    ]},
    { section: "Inventario", items: [
      { label: "Inventario", icon: "fas fa-warehouse", color: "#06b6d4", href: "/PosInventario", desc: "Existencias y movimientos", enabled: p("posInventario") },
      { label: stockBajo && stockBajo.total ? `Stock bajo (${stockBajo.total})` : "Stock bajo", icon: "fas fa-bell", color: stockBajo && stockBajo.agotados ? "#ef4444" : stockBajo && stockBajo.total ? "#f59e0b" : "#10b981", href: "/PosStockBajo",
        desc: stockBajo && stockBajo.agotados ? `${stockBajo.agotados} agotado(s) que se venden` : "Lo que se vende y está por acabarse", enabled: p("posInventario") },
      { label: "Entradas", icon: "fas fa-dolly", color: "#8b5cf6", href: "/PosEntradas", desc: "Alta de mercancía con costo", enabled: p("posEntradas") || p("posCancelarEntradas") },
      { label: porRecibir || pedidos ? `Traspasos (${[porRecibir && `${porRecibir} por recibir`, pedidos && `${pedidos} pedido${pedidos > 1 ? "s" : ""}`].filter(Boolean).join(" · ")})` : "Traspasos", icon: "fas fa-exchange-alt", color: porRecibir || pedidos ? "#ef4444" : "#8b5cf6", href: "/PosTraspasos", desc: "Enviar y recibir entre tiendas", enabled: p("posTraspasos") || p("posRecibir") },
      { label: "Etiquetas", icon: "fas fa-barcode", color: "#0f172a", href: "/PosEtiquetas", desc: "Código de barras por talla y color", enabled: p("posEtiquetas") || p("posEntradas") },
    ]},
    { section: "Dirección", items: [
      { label: "Reportes", icon: "fas fa-chart-line", color: "#2563eb", href: "/PosReportes", desc: "Ventas y comparativos", enabled: p("posReportes") },
      { label: "Faltantes de traspasos", icon: "fas fa-search-minus", color: "#dc2626", href: "/PosFaltantes", desc: "Lo que se envió y no llegó", enabled: p("posReportes") },
      { label: "Promociones", icon: "fas fa-tags", color: "#f59e0b", href: "/PosPromociones", desc: "2x1, 3x1, descuentos", enabled: p("posPromociones") },
      { label: "Tiendas", icon: "fas fa-store", color: "#10b981", href: "/PosTiendas", desc: "Alta de tiendas", enabled: master && p("posTiendas") },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Punto de Venta"
      descripcion={conAcceso ? "Venta en tiendas, corte de caja e inventario" : "Tu usuario no tiene acceso a tiendas; pide que te lo asignen en Usuarios."}
      icono="fas fa-cash-register"
      color="#10b981"
      secciones={SECCIONES}
    />
  );
}

export default BotonesPuntoVenta;
